import fetchApi, { getApiUrl, getCurrentToken } from "../backend/fetchApi";
import { Coupon, CouponShare } from "../models/couponshares";
import { usePlayer } from "../player/playerContext";
import { CreateCouponResponse, RoundCoupon } from "../models/round";

const apiUrl = getApiUrl();

const usePurchaseWithBody = () => {
  const [player] = usePlayer() as any;

  return (body: string | FormData) => {
    return fetchApi(player._links.coupons.href, {
      method: 'POST',
      body: body,
    }).then(response => {
      if (response.ok) {
        return response.json()
      }
      return Promise.reject(response);
    })
      .then((couponResult: CreateCouponResponse) => {
      });
  }

}

export const usePurchaseCoupon = () => {
  const purchaseWithBody = usePurchaseWithBody();

  return (coupon: RoundCoupon) => purchaseWithBody(JSON.stringify(coupon))
}

export const usePurchaseFromFile = () => {
  const purchaseWithBody = usePurchaseWithBody();
  return (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return purchaseWithBody(formData);
  }
}

export const useSimplePurchase = (round: any, stakeMultiplier: number) => {
  const [player] = usePlayer() as any;
  const headers = new Headers({
    Accept: 'application/json',
  });

  const token = getCurrentToken();
  if (token) {
    headers.set('Authorization', "Bearer " + token);
  }

  let feePerRow = round.operatorFeePerRow;
  round.stakeMultiplier = stakeMultiplier;

  return async (coupon: any) => {
    try {
      headers.set('Content-Type', 'application/json');

      coupon.feePerRow = feePerRow;
      coupon.stakeMultiplier = Number(stakeMultiplier);

      const res = await fetch(new URL(player._links.coupons.href, apiUrl + "/").href.replace(/\/$/, ""), {
        headers,
        method: 'POST',
        body: JSON.stringify(coupon),
      });

      return res;
    }
    catch (err) {
      return console.error(err);
    }
  }


}

export const useFreeBetPurchase = () => {
  const [player] = usePlayer() as any;
  const headers = new Headers({
    Accept: 'application/json',
  });

  const token = getCurrentToken();
  if (token) {
    headers.set('Authorization', "Bearer " + token);
  }

  return async (coupon: Coupon) => {

    let couponToPost: any = coupon;

    couponToPost.feePerRow = { amount: "0", currency: coupon.stakePerRow.currency };
    couponToPost.stakeMultiplier = Number(1);

    try {
      headers.set('Content-Type', 'application/json');

      const res = await fetch(new URL(player._links.coupons.href, apiUrl + "/").href.replace(/\/$/, ""), {
        headers,
        method: 'POST',
        body: JSON.stringify(couponToPost),
      });

      return res;
    }
    catch (err) {
      return console.error(err);
    }
  }


}

export class CancelError extends Error {
  constructor(
    public errorCode: number,
    public operatorErrorCode?: string,
    public localizedOperatorMessage?: string,
  ) {
    super(`Cancel failed with error code ${errorCode}`);
  }
}

export const useCancel = () => {
  return async (couponShare: CouponShare) => {
    try {
      let cancelHref = couponShare?._links?.cancel?.href;
      
      if (!cancelHref) {
        throw new Error('Cancel link not found in couponShare');
      }
      
      const res = await fetchApi(cancelHref, { method: 'DELETE' });
      const body = await res.json().catch(() => null);
      if (!res.ok) {
        console.error('Cancel failed', res.status, body);
        throw new CancelError(
          typeof body?.errorCode === 'number' ? body.errorCode : 100,
          body?.operatorErrorCode || undefined,
          body?.localizedOperatorMessage || undefined,
        );
      }
      return body;
    } catch (err) {
      console.error('Network/Fetch error during cancel', err);
      throw err;
    }
  };
};

